export default "__VITE_ASSET__DXDenkbI__"